import { Options, Vue } from 'vue-class-component'
import LeftSideBar from '../LeftSideBar/index.vue'
import { Posts } from '@/services/PostsDataService'
@Options({
  components: {
    LeftSideBar
  }
})
export default class parabillard extends Vue {
  public data:any = ''
  public getData () : any {
    return this.data
  }

  public setData (data:any) : void {
    this.data = data
  }

  async mounted (): Promise<void> {
    try {
      const response = await Posts.PostsDataService.getBySlug('parabillard')
      this.setData(response.data[0])
    } catch (error) {
      console.log(error)
    }
  }
}
